// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".avatar-uploader .el-upload {\n  border-radius: 6px;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n  background-color: #f5f6f9;\n}\n.avatar-uploader .el-upload:hover {\n  border-color: #5669ec;\n}\n.avatar-uploader-icon {\n  color: #5669ec;\n  width: 88px;\n  height: 88px;\n  line-height: 88px !important;\n  text-align: center;\n}\n.avatar {\n  width: 88px;\n  height: 88px;\n  display: block;\n}", ""]);
// Exports
module.exports = exports;
